export { HTMLEditorOptions as default };

/**
* HTML Editor Options
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class HTMLEditorOptions {
  /**
   * Available Fonts
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  fonts;

  /**
   * Availiable Sizes
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Array}
   */
  sizes;

  /**
   * Availiable Styles
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Array}
   */
  styles;

  /**
   * Available Colors
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Array}
   */
  colors = [];


  /**
   * Available Alignments
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Array}
   */
  alignments;

  /**
   * Returns font names
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Array}
   */
  getFontNames() {
    return Object.keys(this.fonts);
  }

  /**
   * Returns font family
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {String|null}
   */
  getFontFamily(font) {
    if (!font) {
      return null;
    }

    if (!this.fonts[font]) {
      return font;
    }

    return this.fonts[font].join(',')
  }
}